// webview 组件通用 API
import jsBridge from "../../common/jsBridge";

/**
 *
 * @param unitId 必填项, 当前广告位 id
 * 以下为选填项
 * 如果提供了 fileURL/filePath/html 任意一个值, 则表示需要 preload
 * 如果同时提供, 则只取 fileURL/filePath/html 顺序中第一个出现的值
 * @param fileURL 选填, 远程 web 页(http/https)
 * @param filePath 选填, 本地 file 协议路径
 * @param html 选填, html 代码片段
 * @param preload 选填, 1 标示非preload（默认），2 preload（IOS实现的所需字段逻辑，Android默认就进行preload）
 * @param rect 选填, 需要 preload 的情况下, 可以通过设置 rect 的值来确定预加载的 webview 的位置和大小
 *                  width 或 height 默认为父视图宽高, 其他值不传则默认为 0
 * @returns {Promise<any>}
 */
export function createWebview({unitId, fileURL, filePath, html, preload, rect}) {
    let params = {
        unitId,
        data: {
            fileURL,
            filePath,
            html,
            preload,
            rect,
        }
    }
    return jsBridge.callNative({fnName: 'VideoBridge/createWebview', params})
}

export function webviewLoad({unitId, id, fileURL, filePath, html, campaigns, unitSetting, preload, rect}) {
    let params = {
        unitId,
        id,
        data: {
            content: {
                fileURL,
                filePath,
                html,
                campaigns,
                unitId,
                unitSetting,
            },
            preload,
            rect,
        }
    }
    return jsBridge.callNative({fnName: 'VideoBridge/webviewLoad', params})
}

export function webviewPreload({unitId, id, fileURL, filePath, html, campaigns, unitSetting, rect}) {
    let preload = 2
    let params = {
        unitId,
        id,
        data: {
            content: {
                fileURL,
                filePath,
                html,
                campaigns,
                unitId,
                unitSetting,
            },
            preload,
            rect,
        }
    }
    console.log('webviewPreload')
    return jsBridge.callNative({fnName: 'VideoBridge/webviewLoad', params})
}

export function webviewReload({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/webviewReload', params})
}

export function webviewGoBack({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/webviewGoBack', params})
}

export function webviewGoForward({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/webviewGoForward', params})
}

export function webviewFireEvent({unitId, id, eventName, eventData}) {
    let params = {
        unitId,
        id,
        data: {
            eventName,
            eventData,
        }
    }
    return jsBridge.callNative({fnName: 'VideoBridge/webviewGoForward', params})
}